module.exports = __webpack_public_path__ + "img/video_icon.2a9dc691.png";